import { render, staticRenderFns } from "./campaign-template-widget.vue?vue&type=template&id=225e9df8&"
import script from "./campaign-template-widget.vue?vue&type=script&lang=js&"
export * from "./campaign-template-widget.vue?vue&type=script&lang=js&"
import style0 from "./campaign-template-widget.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports